<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modalLock"
      title="안내 메시지"
      ok-only
    >
      등록/수정 기간이 아닙니다.<br>
      장학국 간사에게 문의 해주세요! <br>
      Due date for registration is over.
    </b-modal>
    <b-modal
      ref="modalLockButSummit"
      title="안내 메시지"
      ok-only
    >
      서밋장학금 신청서를 위하여 성적표 및 증빙서류만 제출 가능합니다.<br>
      장학국 간사에게 문의 해주세요!<br>
      You can only submit documents for Summit scholarship at the moment.
    </b-modal>
    <b-modal
      ref="modalUpdate"
      title="안내 메시지"
      ok-only
      @hide="$router.push('/remnant/regist')"
    >
      자신의 회원정보가 올바르게 일치하는지 확인해주세요 업데이트사항이 있다면 수정및 기입해주시고 없다면 비밀번호를 입력하고 확인을 눌러주세요
      <br>
      Please update your information before write an apply form including passwords
    </b-modal>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <h3><strong>장학금 신청서</strong></h3>
          </div>
          <longterm-report
            v-if="email !== '' && longterm > 0"
            :email="email"
            :apply-id="applyId"
            :longterm="longterm"
            :lock="lock"
            :summit-lock="summitLock"
            :initial-read-only="true"
            :no-edit="lock && summitLock"
          />
          <apply-info
            v-else-if="email !== '' && longterm <= 0"
            :email="email"
            :apply-id="applyId"
            :lock="lock"
            :summit-lock="summitLock"
            :initial-read-only="true"
            :no-edit="lock && summitLock"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ApplyInfo from './apply/ApplyInfo'
import LongtermReport from './apply/LongtermReport'
import api from '../api'

export default {
  name: 'ApplyRegist',
  components: { ApplyInfo, LongtermReport },
  data: function () {
    return {
      email: '',
      longterm: 0,
      applyId: '',
      lock: true,
      summitLock: true
    }
  },
  created () {
    if (this.$store.getters.isRemnant && this.$store.state.UPDATED !== 1) {
      return
    }
    this.email = this.$store.state.EMAIL
    this.longterm = this.$store.state.LONGTERM
    this.applyId = api.docId('apply', this.email)
  },
  mounted () {
    // IECHECK
    if (window.document.documentMode) {
      alert("인터넷 익스플로러는 지원되지 않습니다. 크롬, 웨일, 사파리, 엣지 등을 사용해주세요 (Internet Explorer is not supported)")
      this.$router.push('/dashboard')
      return
    }
    if (this.$store.getters.isRemnant && this.$store.state.UPDATED !== 1) {
      this.$refs.modalUpdate.show()
      return
    }
    if (this.longterm > 0) {
      this.isLock('longterm', api.currentTerm())
    } else {
      this.isLock('apply', api.currentTerm())
    }
  },
  methods: {
    isLock (docType, term) {
      api.request('get', '/admin/control/lock?doc=' + docType + '&term=' + term)
        .then(response => {
          let data = response.data
          if (!data.lock || this.$store.getters.isRealSuper) {
            this.lock = false
            this.summitLock = false
          } else {
            this.lock = true
            api.request('get', '/admin/control/lock?doc=summit&term=' + term)
              .then(response => {
                let summitData = response.data
                if (!summitData.lock) {
                  // 신청서는 닫혀도 summit은 열려 있을 수 있음
                  this.summitLock = false
                  this.$refs.modalLockButSummit.show()
                } else {
                  this.summitLock = true
                  this.$refs.modalLock.show()
                }
              })
              .catch(error => {
                console.log(error)
                this.$refs.modalLock.show()
                this.summitLock = true
              })
          }
        })
        .catch(error => {
          console.log(error)
          this.$refs.modalLock.show()
          this.lock = true
          this.summitLock = true
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
